export default "<style>\n    .mask {\n        height: 100%;\n        overflow-y: auto;\n        overflow-x: hidden;\n        scroll-snap-type: y mandatory;\n    }\n\n    .wrapper {\n        display: flex;\n        flex-direction: column;\n    }\n</style>\n\n<div class=\"mask\">\n    <div class=\"wrapper\">\n        <slot></slot>\n        <span id=\"infinite-loader\"></span>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./scripts/web-components/municipality-picker-list/template.html
// module id = 279
// module chunks = 0